import React from "react";

function Title({ title }) {
  const { rendered } = title;
  return <span dangerouslySetInnerHTML={{ __html: rendered }} />;
}

export { Title };
